import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { EffectCoverflow, Autoplay } from 'swiper/modules';
import api from '../../../api';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/effect-coverflow';

const Overview = () => {
    const { campus_slug } = useParams();
    const [overviewData, setOverviewData] = useState({
        title: null,
        content: null,
        extendedContent: null,
        images: [],
        loading: true,
        error: null
    });
    const [showExtendedContent, setShowExtendedContent] = useState(false);

    useEffect(() => {
        const fetchOverviewData = async () => {
            try {
                const response = await api.get(`/api/campus/${campus_slug}/overview`);
                
                if (response.data.success) {
                    setOverviewData({
                        title: response.data.data.title || null,
                        content: response.data.data.content || null,
                        extendedContent: response.data.data.extended_content || null,
                        images: response.data.data.images || [],
                        loading: false,
                        error: null
                    });
                } else {
                    setOverviewData(prev => ({
                        ...prev,
                        loading: false,
                        error: response.data.message || 'Failed to load overview data'
                    }));
                }
            } catch (error) {
                setOverviewData(prev => ({
                    ...prev,
                    loading: false,
                    error: error.response?.data?.message || 'Network error'
                }));
            }
        };

        fetchOverviewData();
    }, [campus_slug]);

    const toggleReadMore = () => {
        setShowExtendedContent(!showExtendedContent);
    };

    if (overviewData.loading) {
        return (
            <></>
        );
    }

    if (overviewData.error) {
        return (
            <></>
        );
    }

    if (!overviewData.title && !overviewData.content && overviewData.images.length === 0) {
        return (
            <></>
        );
    }

    return (
        <section className="overview_section mb-0 mb-md-5">
            <div className="container">
                <div className="row">
                    <div className="col-md-12">
                        <div className="ac-overview">
                            <div className="pera-dec">
                                {overviewData.title && ( 
                                    <div className="sec-title text-center">
                  <h2>{overviewData.title}</h2>
                </div>
                               
                                )}
                                <div className="row d-flex justify-content-center align-items-center gap-0 gap-md-5">
                                    {overviewData.content && (
                                        <div className="col-md-6 col-lg-5 col-12 order-2 order-md-1" >
                                            <div dangerouslySetInnerHTML={{ __html: overviewData.content }} />
                                            
                                            {overviewData.extendedContent && (
                                                <>
                                                    <div 
                                                        id="read_more_content" 
                                                        style={{ display: showExtendedContent ? 'block' : 'none' }}
                                                        dangerouslySetInnerHTML={{ __html: overviewData.extendedContent }} 
                                                    />
                                                    <div className="my-3 text-lg-start text-center">
                                                        <button 
                                                            id="read_more_btn" 
                                                            onClick={toggleReadMore} 
                                                            className="readmoreall"
                                                            style={{ 
                                                                display: showExtendedContent ? 'none' : 'inline-block',
                                                                cursor: 'pointer'
                                                            }}
                                                        >
                                                            Read More
                                                        </button>
                                                        <button 
                                                            id="read_less_btn" 
                                                            onClick={toggleReadMore} 
                                                            className="readmoreall"
                                                            style={{ 
                                                                display: showExtendedContent ? 'inline-block' : 'none',
                                                                cursor: 'pointer'
                                                            }}
                                                        >
                                                            Read Less
                                                        </button>
                                                    </div>
                                                </>
                                            )}
                                        </div>
                                    )}
                                    {overviewData.images.length > 0 && (
                                        <div className="col-md-6 col-lg-5 col-12 order-1 order-md-2">
                                            <div className="university-life">
                                                <div className="image diagonal-stripes">
                                                    {overviewData.images.length > 0 ? (
                                                        <Swiper
                                                            effect={'coverflow'}
                                                            grabCursor={true}
                                                            centeredSlides={true}
                                                            slidesPerView={'auto'}
                                                              loop={true} 
                                                            coverflowEffect={{
                                                                rotate: 30,
                                                                stretch: 0,
                                                                depth: 300,
                                                                modifier: 1,
                                                                slideShadows: false,
                                                            }}
                                                            autoplay={{
                                                                delay: 2500,
                                                                disableOnInteraction: true,
                                                            }}
                                                            modules={[EffectCoverflow, Autoplay]}
                                                            className="campusSwiper"
                                                        >
                                                            {overviewData.images.map((img, index) => (
                                                                <SwiperSlide key={index}>
                                                                    <img 
                                                                        src={process.env.REACT_APP_API_URL + '/public/' + img.path} 
                                                                        alt={img.alt || `Campus image ${index + 1}`} 
                                                                        className="swiper-slide-img"
                                                                    />
                                                                </SwiperSlide>
                                                            ))}
                                                        </Swiper>
                                                    ) : (
                                                        <div className="text-center py-5 text-muted">
                                                            No campus images available
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Overview;